/* tslint:disable */
// This file is a stub export filling in missing capabilities in the browser.
// The AadTokenProvider is only supported in Node.
export const AadTokenProvider = undefined;
